import React, { useContext } from "react";
import { store } from "../Store.js";
import { ClientFooter } from "./components/client-footer.js";
import { SocialMedia } from "./components/social-media.js";
import { Logos } from "./components/logos.js";
import { MoreLinks } from "./components/more-links.js";
import { ContactList } from "./components/contact.js";
import { DownloadAppSection } from "./components/download_app.js";
import { ProductsLinks } from "./components/products-links.js";
import { FooterNewsletter } from "./components/newsletter.js";
import { FooterActionPanel } from "./components/action-panel.js";
import { FooterLegalLinks } from "./components/legal-links.js";
import { Recommended } from "./components/recommended.js";
import { useLanguage } from "../../hooks/use-language.js";
import { useTranslationsById } from "../../hooks/use-translations-by-id.js";

const Footer = () => {
	const lang = useLanguage();
	const footerTexts = useTranslationsById({ mainSectionName: "footer", language: lang });
	const globalStateContext = useContext(store);
	const state = globalStateContext?.state;
	const isAuth = state?.sesionActiva !== null && state?.sesionActiva === "SI";
	const footerData = state?.datosHeader || {};

	return (
		<div>
			{isAuth && <ClientFooter clientData={footerData} />}
			<div className="w-100">
				<footer className="footer" id="footer">
					<div className="footer-main-grid p-md-5">
						<section className="footer-column footer-column--contact">
							<h2 className="footer-column-title subheading-2">
								{footerTexts.getText({
									id: "section.contact_sales",
									defaultText: "Representantes comerciales",
								})}
							</h2>
							<ContactList />
						</section>
						<section className="footer-column">
							<ProductsLinks />
						</section>
						<section className="footer-column">
							<MoreLinks />
						</section>
						<section className="footer-column">
							<DownloadAppSection />
						</section>
						<section className="footer-column footer-column--actions">
							<FooterActionPanel />
						</section>
					</div>
					<div className="footer-bottom">
						<div className="footer-bottom__top">
							<FooterNewsletter />
							<SocialMedia />
						</div>
						<div className="footer-bottom__bottom">
							<div className="footer-recommended">
								<Recommended />
								<p>
									{footerTexts.getText({
										id: "recommended.title",
										defaultText: "Software recomendado",
									})}
									:
									<br />
									{footerTexts.getText({
										id: "recommended.items",
										defaultText: "Firefox, Chrome, Safari, NVDA",
									})}
								</p>
							</div>
							<FooterLegalLinks />
							<Logos />
						</div>
					</div>
				</footer>
			</div>
		</div>
	);
};

export default Footer;
